import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBfKlmmlZYyeTKNaDTzqoYRfmXKe35_uMg",
  authDomain: "competitions-24.firebaseapp.com",
  projectId: "competitions-24",
  storageBucket: "competitions-24.firebasestorage.app",
  messagingSenderId: "499383991962",
  appId: "1:499383991962:web:c681373b1c8baccdeaa923",
  measurementId: "G-TL3966ZFL0"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export { firestore };
